import SellerInboundCurationStatusBadge from 'domains/seller-inbound/atoms/curation-status-badge'
import SellerInboundLiveProcessStatus from 'domains/seller-inbound/atoms/live-process-status-badge'
import PropTypes from 'prop-types'
import { Card, CardHeader, Table } from 'reactstrap'
import ProductBrandClassificationBadge from 'domains/product-brand/atoms/classification-badge/product-brand-classification-badge'


const proptypes = {
  inbound: PropTypes.shape({
    id: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    code     : PropTypes.string,
    quantity : PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    live_process_status     : PropTypes.string,
    curation_status         : PropTypes.string,
    tl_brand_classification : PropTypes.object
  })
}

/**
 * Show card information about Seller Inbound
 * @param {object} inbound Seller Inbound
 */
const SellerInboundCard = ({ inbound }) => (
  <Card>

    <CardHeader>
      <div>
        <span className='small text-uppercase text-light font-weight-bolder'>
          { 'Seller Inbound' }
        </span>
        <h2>
          <span className='mr-3'>{ inbound.code }</span>
          <small>
            <ProductBrandClassificationBadge
              classification={ inbound?.tl_brand_classification }
            />
          </small>
        </h2>
      </div>

    </CardHeader>

    <Table hover className='mb-0'>
      <tbody>
        <tr>
          <th scope='row'>ID</th>
          <td>{ inbound.id }</td>
        </tr>
        <tr>
          <th scope='row'>Quantity</th>
          <td>{ inbound.quantity }</td>
        </tr>
        <tr>
          <th scope='row'>Curation Status</th>
          <td>
            <SellerInboundCurationStatusBadge curation_status={ inbound.curation_status } />
          </td>
        </tr>
        <tr>
          <th scope='row'>Live Process Status</th>
          <td>
            <SellerInboundLiveProcessStatus live_process_status={ inbound.live_process_status } />
          </td>
        </tr>
      </tbody>
    </Table>
  </Card>
)

SellerInboundCard.propTypes = proptypes

export default SellerInboundCard